import { Paper, Title } from '@mantine/core';

const Adoration = () => {
  return (
    <Paper p="xl" radius="md" w="100%">
      <Title order={3}>Adoration</Title>
      <p>Adoration content will be implemented here.</p>
    </Paper>
  );
};

export default Adoration;
